import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { GalleryCityRoutes } from '../../../routes';

export const GalleryCityLayout = () => <SwitchRoute routes={GalleryCityRoutes} />;
